import React, { useEffect, useState } from "react";

import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/ab2.png";
import img2 from "../Assets/about page.png";
import img3 from "../Assets/celeb.png";
import Wave from "../Components/Wave";
import Aos from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import axios from "axios";
import { API_URI } from "../Common/data";

function About() {
  const [seo, setSeo] = useState({
    title: 'Cine Celebrate - About Us',
    metaDescription: '',
    metaKeywords: '',
    ogImage: '',
    ogTitle: '',
    ogDescription: '',
    canonicalUrl: ""
  });

  useEffect(() => {
    axios.get(`${API_URI}/page-seo/about`).then(res => {
      if (res.data && res.data.data) setSeo(res.data.data);
    });
  }, []);

  // console.log(seo)


  useEffect(() => {
    Aos.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
      offset: 40,
    });
  }, []);
  return (
    <>
      <Helmet>
        <title>
          {seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
            ? seo.metaTitle
            : "Cine Celebrate - About Us"}
        </title>
        <meta name="title" content={seo.metaTitle && seo.metaTitle.toLowerCase() !== "test title"
          ? seo.metaTitle
          : "Cine Celebrate - About Us"} />
        <meta
          name="description"
          content={
            seo.metaDescription && seo.metaDescription.toLowerCase() !== "test description"
              ? seo.metaDescription
              : "Cine Celebrate - About Us"
          }
        />
        <meta
          name="keywords"
          content={seo?.metaKeywords && Array.isArray(seo?.metaKeywords) ? seo?.metaKeywords.join(", ") : "Private Theater, Celebration, Cine Celebrate"}
        />
        <link rel="canonical" href={seo?.canonicalUrl} />
        <meta property="og:title" content={seo?.ogTitle} />
        <meta property="og:description" content={seo?.ogDescription} />
        <meta property="og:image" content={seo?.ogImage} />
      </Helmet>
      <Navbar />
      <div className="news-banner news-banner3">
        <p>About Us</p>
        <br />
        <h1>Cine Celebrate</h1>
      </div>
      <div className="abs">
        <h4 data-aos="fade-up">
          About Us
        </h4>
        <h2 data-aos="fade-up" data-aos-delay="60">
          Cine Celebrate – Where Your Moments Become Movies
        </h2>
        <p data-aos="fade-up" data-aos-delay="120">
          Welcome to Cine Celebrate, the ultimate destination where life’s
          special moments meet the magic of the big screen. Whether it’s a
          surprise birthday, romantic date night, cozy anniversary, graduation
          celebration, or a joyful bride-to-be party — we don’t just host your
          event, we turn it into a cinematic experience!
        </p>
      </div>
      {/* <img className='foot-img' src={img}/> */}
      {/* <Wave/> */}
      <div className="about-page">
        {/* <img className="about-page-img" src={img} /> */}

        <div className="about-page-div">
          <div className="about-page-left">
            <img src={img2} data-aos="fade-up" />
          </div>
          <div className="about-page-right">
            <h2 data-aos="fade-up">
              Who We Are?
            </h2>
            <p data-aos="fade-up" data-aos-delay="60">
              {/* At Cine Celebrate, we make your birthdays, date nights,
              anniversaries, and more truly unforgettable. Watch your favorite
              movies, shows, photos, or videos on the big screen, and
              personalize your experience décor, and photoshoots. We’re here to
              make your celebrations fun, easy, and memorable—because every
              special moment deserves a grand stage! */}
              We’re not your typical event space. Cine Celebrate offers private
              theaters for unforgettable celebrations — a fusion of
              entertainment, emotion, and experience. Imagine watching your
              favorite movie, memories, or custom slideshow on the big screen,
              surrounded by themed décor, balloons, your closest people, and
              pure veg delights.
            </p>
            <p data-aos="fade-up" data-aos-delay="120">
              We blend comfort, creativity, and technology to give you a
              celebration that’s intimate, immersive, and incredibly unique.
              Whether you're celebrating love, friendship, or milestones — we
              set the stage, you steal the show.
            </p>
          </div>
        </div>

        <div className="about-page-div">
          <div className="about-page-right">
            <h2 data-aos="fade-up">
              What We Can Do?
            </h2>
            {/* <p data-aos="fade-down" data-aos-duration="3000">
              At Cine Celebrate, we turn your special moments into unforgettable
              experiences. Here's what we can do for you
              <br />
              <b>Private Theater Experience</b>: Enjoy a theater all to
              yourself, where you can watch your favorite movies, shows, photos,
              or videos with your loved ones.
              <br />
              
              <b>Personalized Add-Ons</b>: Make your event extra special
              decorations, and photoshoots.
              <br />
              
              <b>Hassle-Free Setup</b>: We handle all the details so you can
              focus on enjoying the moment.
              <br />
              At Cine Celebrate, we bring your celebrations to life—fun,
              exciting, and unforgettable!
            </p> */}
            <p data-aos="fade-up" data-aos-delay="60">
              <b>🎬 Private Theater Magic</b>
              <br />
              Book your own luxury cinema space, perfect for birthdays,
              proposals, baby showers, anniversaries, and more.
              <br />
              <br />
              <b>🎈 Tailored Themes & Décor</b>
              <br />
              From balloon walls to LED lights and romantic setups, we
              personalize the vibe to your vision.
              <br />
              <br />
              <b>📸 Capture the Moment</b>
              <br />
              Enjoy professional photoshoots or opt for instant photo prints
              right at the venue.
              <br />
              <br />
              <b>🍰 Cakes, Food & Custom Add-Ons</b>
              <br />
              Choose from Silver, Gold, or Platinum food packages and add
              delightful surprises with just a few clicks.
              <br />
              <br />
              <b>🎉 Seamless Celebration, Zero Hassle</b>
              <br />
              We handle the setup, the styling, and the ambiance—you just walk
              in and celebrate.
              <br />
              <br />
              At Cine Celebrate, every event is a blockbuster.
              <br />
              <b>🎥 Your story, our screen. Let's celebrate.</b>
            </p>
          </div>
          <div className="about-page-left">
            <img src={img3} data-aos="fade-up" />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default About;
